module.exports = __webpack_public_path__ + "img/icon-doc.1a1e0156.svg";